/**
 * Endkundenrechner API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum Vermittlerart {

    VermittlerartUnknown = 'VermittlerartUnknown',

    VermittlerartAngestellter = 'VermittlerartAngestellter',

    VermittlerartGeneralagent = 'VermittlerartGeneralagent',

    VermittlerartHauptagent = 'VermittlerartHauptagent',

    VermittlerartMakler = 'VermittlerartMakler',

    VermittlerartMehrfachagent = 'VermittlerartMehrfachagent',

    VermittlerartVertriebsorganisation = 'VermittlerartVertriebsorganisation',

    VermittlerartAgentur = 'VermittlerartAgentur',

    VermittlerartAssekuradeur = 'VermittlerartAssekuradeur',

    VermittlerartVermittelndes = 'VermittlerartVermittelndes',

    VermittlerartSonstiger = 'VermittlerartSonstiger'
}

